var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parentx"},[(!_vm.isVerticalNavMenuActive)?_c('div',{directives:[{name:"hammer",rawName:"v-hammer:swipe.right",value:(_vm.onSwipeAreaSwipeRight),expression:"onSwipeAreaSwipeRight",arg:"swipe",modifiers:{"right":true}}],staticClass:"v-nav-menu-swipe-area"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }